/* eslint-disable import/no-cycle */
/**
 * Canvas相关的工具函数
 * 这些函数依赖 @meitu/whee-infinite-canvas,仅在Canvas功能中使用
 */
import useCanvasStore from '$/store/useCanvasStore';
import { FabricObject, Render } from '@meitu/whee-infinite-canvas';
import { useLanguageStore } from '$/store/languageStore';

// 获取平铺数据
export function flattenFabricObjects(render: Render): FabricObject[] {
  const result: FabricObject[] = [];

  function traverse(obj: FabricObject) {
    result.push(obj);

    if (obj._name_ === 'container') {
      (obj as any)._objects.forEach((child: FabricObject) => traverse(child));
    }
  }

  render._FC.forEachObject((obj) => traverse(obj));

  return result;
}

type DefualtNameKey = 'container' | 'image' | 'rectangle' | 'ellipse' | 'arrow' | 'video' | 'audio';
function getDefaultNameMap() {
  const { languageStore } = useLanguageStore.getState();
  const NAME_PREFIX = {
    image: 'Image',
    video: 'Video',
    container: 'Group',
    audio: 'Audio',
    arrow: languageStore.smartcatTranslationText((v) => v.roboneo_web_arrow),
    rectangle: languageStore.smartcatTranslationText((v) => v.roboneo_web_rectangle),
    ellipse: languageStore.smartcatTranslationText((v) => v.roboneo_web_circle),
  };
  return NAME_PREFIX;
}

// 获取默认名字
export function getDefaultName(type: DefualtNameKey): string {
  const { render } = useCanvasStore.getState();
  if (!render) return '';
  const NAME_PREFIX = getDefaultNameMap();
  const flattenArr = flattenFabricObjects(render);
  const prefix = NAME_PREFIX[type];
  const suffix = flattenArr.filter((obj) => obj._name_ === type).length + 1;
  return `${prefix}_${suffix}`;
}
